import React, { useEffect, useState } from "react";

import { Spinner, Button } from "reactstrap";

function Lockable({ link, boxetLink }) {
	const [content, setContent] = useState("");
	const [contentVisible, setContentVisible] = useState(false);

	useEffect(() => {
		fetch(link)
			.then((res) => res.json())
			.then(({ digitalKey }) => setContent(digitalKey));
	}, [link]);

	if (!content) {
		return <Spinner size="sm" />;
	}

	return content.match(
		/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
	) ? (
		<Button
			color="primary"
			outline
			tag="a"
			href={
				!!boxetLink
					? `${process.env.REACT_APP_API_UNLOCK}/${boxetLink}`
					: content
			}
			target="_blank"
			rel="noreferrer"
		>
			Link
		</Button>
	) : contentVisible && !boxetLink ? (
		<p
			style={{
				margin: 0,
				wordWrap: "break-word",
			}}
		>
			{content}
		</p>
	) : !boxetLink ? (
		<Button color="primary" outline onClick={() => setContentVisible(true)}>
			Lockable
		</Button>
	) : (
		<p className="text-truncate text-body word-wrap mb-0">Not Linkable</p>
	);
}

export default Lockable;
